import { render, staticRenderFns } from "./allcontent.vue?vue&type=template&id=22370fd6&scoped=true"
import script from "./allcontent.vue?vue&type=script&lang=js"
export * from "./allcontent.vue?vue&type=script&lang=js"
import style0 from "./allcontent.vue?vue&type=style&index=0&id=22370fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22370fd6",
  null
  
)

export default component.exports